"use strict";

var _extends = Object.assign || function (e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r];

    for (var o in t) {
      Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
  }

  return e;
};

function _objectWithoutProperties(e, r) {
  var t = {};

  for (var o in e) {
    0 <= r.indexOf(o) || Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
  }

  return t;
}

var React = require("react"),
    PropTypes = require("prop-types"),
    Colors = require("@cbrebuild/blocks-base").Colors,
    Icon = function Icon(e) {
  var r = e.children,
      t = _objectWithoutProperties(e, ["children"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20"
  }, t), r);
};

Icon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
}, Icon.defaultProps = {
  className: "",
  style: null,
  fill: Colors.PRIMARY_00
}, module.exports = Icon;